import React from 'react';
import {
  Box,
  FormControl,
  FormLabel,
  FormHelperText,
  TextField,
  FormControlLabel,
  Switch
} from '@mui/material';
import sharedStyles from '../../../../../IndeedIntegration/AdEditor/useStyles';
import usestyles from '../useStyles';
import { stepPropTypes } from '../../../../../IndeedIntegration/AdEditor/Steps/types';

const MAX_KEY_SELLING_POINTS = 3;
const MAX_CHAR_LIMIT = 80;

function Step2({ answers, setAnswers }) {
  const sharedClasses = sharedStyles();
  const classes = usestyles();

  return (
    <div className={sharedClasses.stepContainer}>
      <h4>Feature Job on Viewjobs</h4>
      <Box className={classes.switchContainer}>
        <FormLabel>From $350 + GST, boost visibility and attract more candidates.</FormLabel>
        <FormControlLabel
          control={
            <Switch
              checked={answers.featured}
              onChange={() => setAnswers({ ...answers, featured: !answers.featured })}
              color="secondary"
            />
          }
          label=""
        />
      </Box>

      {answers.featured && (
        <FormControl
          fullWidth={true}
          className={`${sharedClasses.formControl} ${sharedClasses.medium}`}
        >
          <FormLabel required={false} className={sharedClasses.label}>
            Short Summary (Optional)
          </FormLabel>
          <TextField
            className={sharedClasses.textField}
            variant="outlined"
            value={answers.jobPreview.summary}
            onChange={(e) =>
              e.target.value.length <= 150 &&
              setAnswers({
                ...answers,
                jobPreview: { ...answers.jobPreview, summary: e.target.value }
              })
            }
          />
          <FormHelperText className={sharedClasses.helperText}>
            {answers.jobPreview?.summary?.length || 0}/150
          </FormHelperText>
        </FormControl>
      )}

      {answers.featured && (
        <FormControl
          fullWidth={true}
          className={`${sharedClasses.formControl} ${sharedClasses.medium}`}
        >
          <FormLabel required={false} className={sharedClasses.label}>
            Key Selling Points (Optional)
          </FormLabel>
          <span className={sharedClasses.subLabel}>
            Enter {MAX_KEY_SELLING_POINTS} key selling points to attract candidates to view your
            role
          </span>
          {Array.from({ length: MAX_KEY_SELLING_POINTS }).map((_, index) => (
            <FormControl
              key={index}
              fullWidth={true}
              className={`${sharedClasses.formControl} ${sharedClasses.medium}`}
            >
              <TextField
                className={sharedClasses.textField}
                variant="outlined"
                value={answers.jobPreview[`key${index + 1}`]}
                onChange={(e) =>
                  e.target.value.length <= MAX_CHAR_LIMIT &&
                  setAnswers({
                    ...answers,
                    jobPreview: { ...answers.jobPreview, [`key${index + 1}`]: e.target.value }
                  })
                }
              />
              <FormHelperText className={sharedClasses.helperText}>
                {answers.jobPreview?.[`key${index + 1}`]?.length || 0}/{MAX_CHAR_LIMIT}
              </FormHelperText>
            </FormControl>
          ))}
        </FormControl>
      )}

      <h4>Job description</h4>
      <FormControl
        fullWidth={true}
        style={{ margin: '0.5rem 0 1.5rem 0' }}
        className={`preview-html ${classes.formControl} ${classes.large}`}
      >
        <div dangerouslySetInnerHTML={{ __html: answers.description || 'No description' }} />
      </FormControl>
    </div>
  );
}

Step2.propTypes = stepPropTypes;

export default Step2;
